import { TabConfig } from "src/app/shared/ui/tabs/tabs.component";

export const coordinates = {
  longitude: {
    min: 7,
    max: 12
  },
  latitude: {
    min: 47,
    max: 50
  }
};

export const SETTINGS_TABS: Array<TabConfig> = [
  {
    name: "municipalSettings",
    label: "CONFIGURATION_AREA.DIALOGS.SETTINGS.TABS.COMMUNE.TITLE"
  },
  {
    name: "contactSettings",
    label: "CONFIGURATION_AREA.DIALOGS.SETTINGS.TABS.CONTACT_DATA"
  },
  {
    name: "moduleSettings",
    label: "CONFIGURATION_AREA.DIALOGS.SETTINGS.TABS.MODULE"
  }
];
